<template src='./DatosInicioSeguimiento.html'>
</template>
<script>
import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import ComponenteSelect from '../ComponenteSelect/ComponenteSelect'
import {serverBus} from '../../main'
Vue.use(VueMaterial)
export default {
  data() {
    return {
      seguimiento:[
        {
          "nombre_lista": "Tipo Contacto",
          "key_lista":"tipo_contacto",
          "valores_lista":[
                            
              {
                "nombre":"Linea 7x24",
                "key":"linea_7x24",
                "valor":""
              },
              {
                "nombre":"Llamada telefónica",
                "key":"llamada_telefonica",
                "valor":""
              },
              {
                "nombre":"Consulta médica",
                "key":"consulta_medica",
                "valor":""
              },
            ]
        },
        
        {  
          "nombre_lista": "Comunicante",
          "key_lista":"comunicante",
          "valores_lista":[
              
              {
                "nombre":"Paciente",
                "key":"paciente",
                "valor":""
              },
                {
                "nombre":"Cuidador primario",
                "key":"cuidadorprimario",
                "valor":""
              },
              {
                "nombre":"Otro",
                "key":"otro",
                "valor":""
              }
            ]
        },
        {
          "nombre_lista": "Motivo",
          "key_lista":"motivo",
          "valores_lista":[
              
              {
                "nombre":"Emergencia del paciente",
                "key":"emergenciadelpaciente",
                "valor":""
              },
              {
                "nombre":"Pregunta informativa",
                "key":"preguntainformativa",
                "valor":""
              },
              {
                "nombre":"Petición de orden o cita",
                "key":"peticiondeordenocita",
                "valor":""
              }
            ]
        } 
        ],
       arrayElementoSeleccionado: []
    }
  },
  
  mounted(){
    serverBus.$on('jsonSeleccion',(jsonSeleccion) =>{
      this.seleccionSeguimientos(jsonSeleccion);
    });
  },
  beforeDestroy() {
    serverBus.$off('jsonSeleccion')
  },
  components: {
    ComponenteSelect
  },
  methods:{
    seleccionSeguimientos (jsonSeleccion) { 
      const {nombreCampo,valorCampo,index} = jsonSeleccion
      const result = this.arrayElementoSeleccionado.filter(elemento => elemento.nombreCampo == nombreCampo)
      if(result.length >= 1){
        this.arrayElementoSeleccionado[index].valorCampo = valorCampo
      }else{    
        this.arrayElementoSeleccionado.push({nombreCampo, valorCampo})
      }      
    }
  },

}
</script>
<style lang="scss" scoped src='./DatosInicioSeguimiento.css'>
</style>



// WEBPACK FOOTER //
// src/components/DatosInicioSeguimiento/DatosInicioSeguimiento.vue